var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinmobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0209055689 8.90302917e-06 29.4377241 8.90302917e-06 29.4377241 29.4690265 0.0209055689 29.4690265"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Homepage-large-screen",
    transform: "translate(-1745.000000, -5833.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1664.000000, 5833.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(81.530973, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3973808,24.6684331 L15.8400937,24.6684331 L15.8400937,17.2381875 C15.8400937,16.8408898 15.8692049,16.4427909 15.986455,16.1591404 C16.3075735,15.3640999 17.03862,14.5412374 18.2662576,14.5412374 C19.8736387,14.5412374 20.5169489,15.7613976 20.5169489,17.5505058 L20.5169489,24.6684331 L24.9596618,24.6684331 L24.9596618,17.0387597 C24.9596618,12.9516461 22.767998,11.0497365 19.8448852,11.0497365 C17.448235,11.0497365 16.3956675,12.3831431 15.8109824,13.2913411 L15.8404514,13.2913411 L15.8404514,11.3620102 L11.3977832,11.3620102 C11.4556034,12.610393 11.3973808,24.6688337 11.3973808,24.6688337 L11.3973808,24.6684331 Z M6.71744001,9.54512454 C8.26650912,9.54512454 9.2309378,8.52323485 9.2309378,7.24631789 C9.20182651,5.94033254 8.26650912,4.94706609 6.74695375,4.94706609 C5.22614628,4.94706609 4.23300878,5.94033254 4.23300878,7.24631789 C4.23300878,8.52323485 5.197035,9.54512454 6.688284,9.54512454 L6.71703755,9.54512454 L6.71744001,9.54512454 Z M8.93821512,24.6684331 L8.93821512,11.3616096 L4.49505506,11.3616096 L4.49505506,24.6684331 L8.93861758,24.6684331 L8.93821512,24.6684331 Z M0.0209055689,2.11100615 C0.0209055689,0.945733176 0.994635543,8.90302917e-06 2.19512945,8.90302917e-06 L27.2635673,8.90302917e-06 C28.4643742,8.90302917e-06 29.4377465,0.945733176 29.4377465,2.11100615 L29.4377465,27.3584388 C29.4377465,28.5240679 28.4643742,29.4690355 27.2635673,29.4690355 L2.19512945,29.4690355 C0.994635543,29.4690355 0.0209055689,28.5240679 0.0209055689,27.358795 L0.0209055689,2.11060551 L0.0209055689,2.11100615 Z",
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinmobile);
export default __webpack_public_path__ + "static/media/linkedin(mobile).f6eb014559cd31c59f29327174e98a9b.svg";
export { ForwardRef as ReactComponent };